"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Form_1 = require("@reactionable/core/lib/form/Form");
const FormButton_1 = require("./FormButton");
function Form(props) {
    return (jsx_runtime_1.jsx(Form_1.Form, Object.assign({}, props, { form: Object.assign({ className: "needs-validation mb-1" }, props.form), FormButtonComponent: FormButton_1.FormButton }), void 0));
}
exports.Form = Form;
//# sourceMappingURL=Form.js.map